import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {AuthenticationService} from '../../original-services/authentication.service';
import {appVersion} from '../../../environments/version';

@Injectable({
    providedIn: 'root'
})
export class AppVersionService {

    public timer;

    constructor(
        private readonly authenticationService: AuthenticationService
    ) {
    }

    setupVersionCheck(): void {
        fetch(environment.versionFile)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Cannot load version');
                }
                return response.text();
            })
            .then(lastVersion => {
                this.checkVersion(appVersion, lastVersion).then();
                this.timer = setInterval(() => {
                    fetch(environment.versionFile)
                        .then(response => response.text())
                        .then(lastVersionUpdated => {
                            this.checkVersion(appVersion, lastVersionUpdated).then();
                        })
                        .catch(() => {
                            console.error('Cannot update version');
                        });
                }, 120000);
            })
            .catch(() => {
                console.error('Cannot load version');
            });
    }

    async checkVersion(currentVersion: any, lastVersion: any): Promise<void> {
        if (String(currentVersion).toLowerCase().trim() !== String(lastVersion).toLowerCase().trim()) {
            clearTimeout(this.timer);
            this.authenticationService.newVersionArrived$.next(true);
        }
    }

}
